// @flow

import { createStore, compose, applyMiddleware } from 'redux';
import thunk          from 'redux-thunk';
import apiMiddleware  from 'redux-devise-axios';
import rootReducer    from './reducers/index';
import axios          from 'axios';

// Axios options
const options = { axios }

// Enhancers
const enhancers = compose(
  applyMiddleware(thunk, apiMiddleware(options)),
  window.devToolsExtension ? window.devToolsExtension() : f => f
);

// Store
const store = createStore(rootReducer, {}, enhancers);

declare var module : {
  hot : {
    accept(path:string, callback:() => void): void;
  };
};

if(module.hot) {
  module.hot.accept('./reducers/',() => {
    const nextRootReducer = require('./reducers/index').default;
    store.replaceReducer(nextRootReducer);
  });
}

export default store;




// WEBPACK FOOTER //
// ./src/store.js